import { ProjectAdapter } from "./adapter/project";
import { InvoiceAdapter } from "./adapter/invoice";
import { ProfileAdapter } from "./adapter/profile";
import { MemberAdapter } from "./adapter/member";
import { PlanAdapter } from "./adapter/plan";

import { IAccountRepo } from "./irepo";

import { TError } from "../../types/error";

export class AccountUsecase {
  private repo: IAccountRepo;
  private error: (error: TError) => void;

  constructor(repo: IAccountRepo, error: (error: TError) => void) {
    this.repo = repo;
    this.error = error;
  }

  async fetchPlan(): Promise<any> {
    try {
      const data = await this.repo.fetchPlan();
      return PlanAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async updatePlan(req: any): Promise<any> {
    try {
      const dto = PlanAdapter.toInputDTO(req);
      return await this.repo.updatePlan(dto);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async updateProject(req: any): Promise<any> {
    try {
      const dto = ProjectAdapter.toInputDTO(req);
      return await this.repo.updateProject(dto);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchProfile(): Promise<any> {
    try {
      const data = await this.repo.fetchProfile();
      return ProfileAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async editProfile(req: any): Promise<any> {
    try {
      const dto = ProfileAdapter.toInputDTO(req);
      return await this.repo.editProfile(dto);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchMember(): Promise<any> {
    try {
      const data = await this.repo.fetchMember();
      return MemberAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async addMember(req: any): Promise<any> {
    try {
      return await this.repo.addMember(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async editMember(req: any): Promise<any> {
    try {
      return await this.repo.editMember(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async selfEditMember(req: any): Promise<any> {
    try {
      return await this.repo.selfEditMember(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async deleteMember(req: any): Promise<any> {
    try {
      return await this.repo.deleteMember(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async resetMfa(req: any): Promise<any> {
    try {
      return await this.repo.resetMfa(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async fetchInvoice(): Promise<any> {
    try {
      const data = await this.repo.fetchInvoice();
      return InvoiceAdapter.toOutputDTO(data);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async requestExpertRole(req: any): Promise<any> {
    try {
      return await this.repo.requestExpertRole(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async rejectRoleRequest(req: any): Promise<any> {
    try {
      return await this.repo.rejectRoleRequest(req);
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }

  async acceptInsVendor(): Promise<any> {
    try {
      return await this.repo.acceptInsVendor();
    } catch (error) {
      this.error({ id: null, error });
      throw error;
    }
  }
}
